export const API_URL = process.env.REACT_APP_API_URL;
export const ITEMS_PER_PAGE = process.env.REACT_APP_ITEMS_PER_PAGE ? +process.env.REACT_APP_ITEMS_PER_PAGE : 10;
export const ZOOMS = [1, 2, 4, 8, 10];
export const TILES_URL = process.env.REACT_APP_TILES_URL;
export const THUMBS_URL = process.env.REACT_APP_THUMBS_URL;
export const JPG_URL = process.env.REACT_APP_JPG_BASE_URL;
export const FEEDBACK_URL = 'https://www.surveymonkey.com/r/YQG8WGW';
export const PRIVACY_URL = 'https://p.lodz.pl/polityka-prywatnosci';
